import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { SpinnerModule } from '../../components/spinner/spinner.module';
import { ActionMenuComponent } from './action-menu/action-menu.component';
import { CoreActionMenuModule } from './action-menu/action-menu.module';
import { CreateLeadCarComponent } from './create-lead-car/create-lead-car.component';
import { CreateLeadComponent } from './create-lead/create-lead.component';

import { GeneralDropdownComponent } from './general-dropdown/general-dropdown.component';
import { OrderServiceFeeControlComponent } from './order-service-fee-control/order-service-fee-control.component';
import { QuoteNoteControlComponent } from './quote-note-control/quote-note-control.component';
import { StateControlComponent } from './state-control/state-control.component';

@NgModule({
  declarations: [
    GeneralDropdownComponent,
    OrderServiceFeeControlComponent,
    QuoteNoteControlComponent,
    CreateLeadComponent,
    CreateLeadCarComponent,
    StateControlComponent,
  ],
  exports: [
    GeneralDropdownComponent,
    ActionMenuComponent,
    OrderServiceFeeControlComponent,
    QuoteNoteControlComponent,
    CreateLeadComponent,
    CreateLeadCarComponent,
    StateControlComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatAutocompleteModule,
    CoreActionMenuModule,
    SpinnerModule,
  ]
})
export class CustomControlsModule { }
